export function validate(formObj) {
  var isFormValid = true;
  Object.keys(formObj).forEach(function (key, i) {
    if (key == 'contact') {
      Object.keys(formObj[key]).forEach((k) => {
        if (!formObj[key][k].isValid)
        {  isFormValid = false;
        }
        
        formObj[key][k].isDirty = true;
      });
    }
    else {     
        if ((!formObj[key].ref && !formObj[key].isValid) || (formObj[key].ref && !formObj[key].ref.getValidity()))
        { 
					isFormValid = false;
        }
        formObj[key].isDirty = true;
    }

  });
  return isFormValid;
}

